import _ from 'lodash';
import globalStore from '$$globalStore';
import svg from '$$helpers/svgToURI';
import icon_resource from '../../svg/default/default-ava.svg';

export default function (options, ganttId) {
  const resources = globalStore.getters['resourcesModel/getResourcesByProjectIdForUI'](ganttId);

  return options.reduce((result, option) => {
    const resource = resources.find(item => item.id === option.resource_id);

    if (resource) {
      result.push({
        ...resource,
        id: option.id,
        sort_order: option.sort_order,
        picture: resource.picture || svg(icon_resource),
        value: resource.name,
      });
    }

    return result;
  }, []);
}
